export default __webpack_public_path__ + "static/media/codeImg.a63bfa5b.png";